import React, { useState } from 'react'
import styles from './styles.module.css'

function CategoriesBusiness({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  // Toggle expand/collapse state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  // Limit the display of categories to 5 unless expanded
  const categoriesToShow = isExpanded
    ? record.categories
    : record.categories?.slice(0, 5) || []

  return (
    <div className={styles.CategoriesBusinessContainer}>
      <h1 className={styles.CategoriesBusinessTitle}>Categories</h1>

      <div className={styles.CategoriesBusinessList}>
        {categoriesToShow.length > 0 ? (
          categoriesToShow.map((category, index) => (
            <span key={index} className={styles.CategoriesBusinessItem}>
              {category}
            </span>
          ))
        ) : (
          <span className={styles.NoCategoriesNumbers}>N/A</span>
        )}
      </div>

      {/* Show the expand button only if there are more than 5 categories */}
      {record.categories && record.categories.length > 5 && (
        <button
          className={styles.CategoriesBusinessButton}
          onClick={toggleExpand}
        >
          {isExpanded ? 'Show less' : `Expand all (${record.categories.length})`}
        </button>
      )}
    </div>
  )
}

export default CategoriesBusiness
